import { useState, useEffect } from "react";

export const useInventoryState = (onInventoryStateChange: (isActive: boolean) => void) => {
  const [isInventoryActive, setIsInventoryActive] = useState(false);

  const handleInventoryComplete = () => {
    setIsInventoryActive(false);
  };

  useEffect(() => {
    onInventoryStateChange(isInventoryActive);
  }, [isInventoryActive, onInventoryStateChange]);

  return {
    isInventoryActive,
    setIsInventoryActive,
    handleInventoryComplete,
  };
};